// extracted by mini-css-extract-plugin
module.exports = {"register":"Register_register__1CVdO","iconDiv":"Register_iconDiv__xznyG","registerForm":"Register_registerForm__2n82P","registerButtonDiv":"Register_registerButtonDiv__2LiwI"};